/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./assets/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 208);
/******/ })
/************************************************************************/
/******/ ({

/***/ 208:
/***/ (function(module, exports) {

var __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

window.UTIL = {
  keys: function(obj) {
    var k, keys;
    if (typeof obj !== "object") {
      return [];
    }
    keys = [];
    for (k in obj) {
      keys.push(k);
    }
    return keys;
  },
  contains: function(a, obj) {
    var i;
    if (((a != null ? a.length : void 0) == null) || (obj == null)) {
      return;
    }
    i = 0;
    while (i < a.length) {
      if (a[i] === obj) {
        return true;
      }
      i++;
    }
    return false;
  },
  debounce: function(func, wait, immediate) {
    var timeout;
    timeout = void 0;
    return function() {
      var args, callNow, context, later;
      context = this;
      args = arguments;
      later = function() {
        timeout = null;
        if (!immediate) {
          func.apply(context, args);
        }
      };
      callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) {
        func.apply(context, args);
      }
    };
  },
  clone: function(obj) {
    return JSON.parse(JSON.stringify(obj));
  },
  getQueryParam: function(variable, query) {
    var i, pair, v, variables, vars, _i, _len, _ref;
    if (query == null) {
      query = window.location.search.substring(1);
    }
    variables = [];
    if (typeof variable === 'string') {
      variables = [variable.toLowerCase()];
    } else {
      for (_i = 0, _len = variable.length; _i < _len; _i++) {
        v = variable[_i];
        variables.push(v.toLowerCase());
      }
    }
    vars = query.split('&');
    i = 0;
    while (i < vars.length) {
      pair = vars[i].split('=');
      if (_ref = pair[0].toLowerCase(), __indexOf.call(variables, _ref) >= 0) {
        return this.parseValues(pair[1]);
      }
      i++;
    }
    return null;
  },
  getQueryAsObj: function(query) {
    var i, pair, tmp, vars;
    if (query == null) {
      query = window.location.search.substring(1);
    }
    tmp = {};
    vars = query.split('&');
    i = 0;
    while (i < vars.length) {
      pair = vars[i].split('=');
      tmp[pair[0]] = pair[1];
      i++;
    }
    return tmp;
  },
  parseValues: function(v) {
    if (typeof v !== 'string') {
      return v;
    }
    if (v === '') {
      return null;
    }
    if (v === 'true') {
      return true;
    }
    if (v === 'false') {
      return false;
    }
    if (!isNaN(Number(v))) {
      return Number(v);
    }
    if (v === 'null') {
      return null;
    }
    return v;
  },
  hexToString: function(int) {
    var k;
    k = (int + Math.pow(16, 6)).toString(16).substr(-6);
    return "#" + k.toString(16);
  }
};


/***/ })

/******/ });


// WEBPACK FOOTER //
// a-util.js